import { clamp } from './constants.js';

export const POLE_DEFAULTS = {
  'light-pole': { kind: 'light-pole', width: 0.2, depth: 0.2, height: 6, armLength: 1.2 },
  'utility-pole': { kind: 'utility-pole', width: 0.3, depth: 0.3, height: 9, armLength: 1.4 }
};
export const isPoleObject = o => !!POLE_DEFAULTS[o?.kind];
export const poleDiameter = o => clamp(o.width || 0.2, 0.08, 1.5);
export const poleArmLength = o => clamp(o.armLength ?? POLE_DEFAULTS[o.kind]?.armLength ?? 1.2, 0, 5);

/** Narrow solid volumes are shared by coverage, walking and plan rendering.
 * The 3D shaft is cylindrical; its conservative box bounds block rays. */
export function poleParts(o) {
  const d = poleDiameter(o), h = o.height, arm = poleArmLength(o), light = o.kind === 'light-pole';
  const part = (role, x, y, z, width, depth, height, color) => ({ role, x, y, z, width, depth, height, color });
  const metal = '#707980';
  const parts = [part('shaft', 0, 0, h / 2, d, d, h, light ? metal : '#876a48'),
    part('base', 0, 0, Math.min(0.12, h / 20), d * 1.7, d * 1.7, Math.min(0.24, h / 10), '#565f65')];
  if (arm > 0) {
    if (light) parts.push(part('arm', arm / 2, 0, h - 0.15, arm, 0.075, 0.075, metal),
      part('luminaire', arm, 0, h - 0.18, 0.55, 0.25, 0.16, '#414c56'));
    else {
      parts.push(part('crossarm', 0, 0, h - 0.45, 0.13, arm, 0.16, '#65513e'));
      for (const sign of [-1, 1]) parts.push(part('insulator', 0, sign * arm * 0.4, h - 0.24, 0.13, 0.13, 0.26, '#a1afb0'));
    }
  }
  return parts;
}
